import script from "./InviteTeamMemberDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteTeamMemberDialog.vue?vue&type=script&setup=true&lang=js"

import "./InviteTeamMemberDialog.vue?vue&type=style&index=0&id=7e31e9f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e31e9f6"]])

export default __exports__